export default class BackLogisticsList {
    companyId: number;
    companyCode: number;
    companyName: string;
}